import 'css-chunksrc/client/scenes/optimizedGantt/graph/elementsOverlay/element/milestone/styles.scss';export default {
  "milestone": "_milestone_z1t0q_1",
  "iconBox": "_iconBox_z1t0q_11",
  "icon": "_icon_z1t0q_11",
  "blocked": "_blocked_z1t0q_26"
};